import { gql, TypedDocumentNode } from '@common/hooks';
import {
  LoadBalancingWorkerQueryCgResponse,
  LoadBalancingWorkerQueryVariables,
} from '@common/graphql';

export type LoadBalancingWorkerType = NonNullable<
  LoadBalancingWorkerQueryCgResponse['loadBalancingWorker']
>;

export type LoadBalancingWorkerTermType =
  LoadBalancingWorkerType['terms'][number];

export const LOAD_BALANCING_WORKER_QUERY: TypedDocumentNode<
  LoadBalancingWorkerQueryCgResponse,
  LoadBalancingWorkerQueryVariables
> = gql`
  query LoadBalancingWorker(
    $id: ID!
    $scheduleGroupId: ID!
    $schedulingPeriodId: ID
  ) {
    loadBalancingWorker(
      id: $id
      serviceLineId: $scheduleGroupId
      schedulingPeriodId: $schedulingPeriodId
    ) {
      id
      name
      homeUnit {
        canManageWorkerProfile {
          value
        }
      }
      terms {
        id
        active
        effectiveStartDate
        effectiveEndDate
        employmentType
        role
        homeUnit
        ftePercentage
        preferredTime
        shiftPatternPreference
        chargeEligible
        skills {
          id
          name
        }
      }
    }
  }
`;
